import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../Styles/thought.css";

const ITEMS_PER_PAGE = 9;
const MIN_PAGES = 5;

const blogs = [
    // ✅ NEW BLOG ALWAYS FIRST
  { id: 4, image: "/assets/d_4.png", title: "Shaping the Future of Work HR Voices by Outstanding Workplaces", path: "/shaping-future" },
  { id: 1, image: "/assets/d_1.png", title: "Visionary Leadership: Shaping Culture Through Forward-Thinking Impact", path: "/visionary-tech"  },
  { id: 2, image: "/assets/d_2.png", title: "Foster an environment where every employee feels valued, heard, and empowered to contribute", path: "/foster-environment"  },
  { id: 3, image: "/assets/d_3.png", title: "Cultivating a Learning-First Culture", path: "/learning-culture"  },
];

const categories = [
  { label: "All Blogs", path: "/blogs" },
  { label: "Workplace Best Practices", path: "/work" },
  { label: "Employee Engagement", path: "/Engagement" },
  { label: "Employee Branding", path: "/Brand"},
  { label: "Thought Leadership & Workplace Culture", path: "/Thought" },
];

const getPageWindow = (current, total) => {
  const windowSize = 1;
  let start = Math.max(1, current - Math.floor(windowSize / 2));
  let end = start + windowSize - 1;
  if (end > total) {
    end = total;
    start = Math.max(1, end - windowSize + 1);
  }
  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
};

const CustomDropdown = ({ selected, setSelected, onNavigate }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="thought-dropdown">
      <div className="thought-dropdown__header" onClick={() => setOpen(!open)}>
        <span>{selected}</span>
        <span className={`thought-dropdown__arrow ${open ? "open" : ""}`}>
          <img src="/assets/arrow_1.png" alt="arrow" />
        </span>
      </div>

      {open && (
        <div className="thought-dropdown__list">
          {categories.map((item, index) => (
            <div
              key={index}
              className="thought-dropdown__item"
              onClick={() => {
                setSelected(item.label);
                setOpen(false);
                onNavigate(item.path);
              }}
            >
              {item.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const BlogPage = () => {
  const navigate = useNavigate();
  const handleCardClick = (path) => {
  if (path) {
    navigate(path);
  }
};
  const [selectedCategory, setSelectedCategory] = useState("Thought Leadership & Workplace Culture");
  const [currentPage, setCurrentPage] = useState(1);

  const realTotalPages = Math.ceil(blogs.length / ITEMS_PER_PAGE);
  const totalPages = Math.max(realTotalPages, MIN_PAGES);

  const handlePageChange = (n) => {
    if (n < 1 || n > totalPages) return;
    setCurrentPage(n);
  };

  const pageBlogs = blogs.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const pageWindow = getPageWindow(currentPage, totalPages);

  return (
    <div className="thought">
      <div className="thought__header">
        <h2 className="thought__title-main">Thought Leadership & Workplace Culture</h2>
        <CustomDropdown
          selected={selectedCategory}
          setSelected={(label) => {
            setSelectedCategory(label);
            setCurrentPage(1);
          }}
          onNavigate={(path) => navigate(path)}
        />
      </div>

      <div className="thought__grid">
        {pageBlogs.length > 0 ? (
          pageBlogs.map((blog) => (
            <div
  className="thought-card"
  key={blog.id}
  onClick={() => handleCardClick(blog.path)}
  style={{ cursor: "pointer" }}
>
              <div className="thought-card__image-wrapper">
                <img src={blog.image} alt="" className="thought-card__image" />
              </div>
              <p className="thought-card__title">{blog.title}</p>
            </div>
          ))
        ) : (
          <p className="thought__no-results">No blogs found.</p>
        )}
      </div>

      <div className="thought-pagination">
        <button
          className="thought-pagination__btn"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          ← Previous
        </button>

        <div className="thought-pagination__numbers">
          {pageWindow.map((n) => {
            const isDisabled = n > realTotalPages;
            return (
              <span
                key={n}
                className={`thought-pagination__number 
                  ${n === currentPage ? "thought-pagination__number--active" : ""}
                  ${isDisabled ? "thought-pagination__number--disabled" : ""}
                `}
                onClick={() => !isDisabled && handlePageChange(n)}
              >
                {n}
              </span>
            );
          })}
        </div>

        <button
          className="thought-pagination__btn"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === realTotalPages}
        >
          Next →
        </button>
      </div>
    </div>
  );
};

export default BlogPage;